import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    updateEmployees: false,
    updateCompanies: false,
    updateEmpLeave: false,
    updateEmpSalaryComponents: false,
    updateEmpEarningComponents: false,
    updateEmpDeductionComponents: false,
    updateAllowances: false,
    updateCompanyHolidays: false,
    updateLeaveMaster: false,
    updatePTslabsConfig: false,
};

const updateTableSlice = createSlice({
    name: 'updateTable',
    initialState,
    reducers: {
        startUpdateEmployees(state) {
            state.updateEmployees = true;
        },
        stopUpdateEmployees(state) {
            state.updateEmployees = false;
        },
        startUpdateEmpLeave(state) {
            state.updateEmpLeave = true;
        },
        stopUpdateEmpLeave(state) {
            state.updateEmpLeave = false;
        },
        startUpdateEmpSalComponents(state) {
            state.updateEmpSalaryComponents = true;
        },
        stopUpdateEmpSalComponents(state) {
            state.updateEmpSalaryComponents = false;
        },
        startUpdateEmpEarningComponents(state) {
            state.updateEmpEarningComponents = true;
        },
        stopUpdateEmpEarningComponents(state) {
            state.updateEmpEarningComponents = false;
        },
        startUpdateEmpDeductionComponents(state) {
            state.updateEmpDeductionComponents = true;
        },
        stopUpdateEmpDeductionComponents(state ){
            state.updateEmpDeductionComponents = false;
        },
        startUpdateAllowances(state) {
            state.updateAllowances = true;
        },
        stopUpdateAllowances(state) {
            state.updateAllowances = false;
        },
        startUpdateCompanyHolidays(state) {
            state.updateCompanyHolidays = true;
        },
        stopUpdateCompanyHolidays(state) {
            state.updateCompanyHolidays = false;
        },
        startUpdateLeaveMaster(state){
            state.updateLeaveMaster = true;
        },
        stopUpdateLeaveMaster(state){
            state.updateLeaveMaster = false;
        },
        startUpdateCompanies(state){
            state.updateCompanies = true;
        },
        stopUpdateCompanies(state) {
            state.updateCompanies = false;
        },
        startUpdatePTslabsConfig(state) {
            state.updatePTslabsConfig = true;
        },
        stopUpdatePTslabsConfig(state) {
            state.updatePTslabsConfig = false;
        },
    }
});

export const updateTableActions = updateTableSlice.actions;
export default updateTableSlice;